// extracted by mini-css-extract-plugin
export default {"root":"Backdrop_root__hbB7S","fullscreen":"Backdrop_fullscreen__yTb90"};